import React from "react";

const SightForm = () => {
  return (
    <>
      <div className="bf-wrap">
        <form className="bf-form">
          <div className="bf-field">
            <div className="bf-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="32"
                viewBox="0 0 26 32"
                fill="none"
              >
                <path
                  d="M12.8 16C11.04 16 9.6 14.56 9.6 12.8C9.6 11.04 11.04 9.6 12.8 9.6C14.56 9.6 16 11.04 16 12.8C16 14.56 14.56 16 12.8 16ZM22.4 13.12C22.4 7.312 18.16 3.2 12.8 3.2C7.44 3.2 3.2 7.312 3.2 13.12C3.2 16.864 6.32 21.824 12.8 27.744C19.28 21.824 22.4 16.864 22.4 13.12ZM12.8 0C19.52 0 25.6 5.152 25.6 13.12C25.6 18.432 21.328 24.72 12.8 32C4.272 24.72 0 18.432 0 13.12C0 5.152 6.08 0 12.8 0Z"
                  fill="currentColor"
                ></path>
              </svg>
            </div>
            <div className="bf-control">
              <label className="bf-label" htmlFor="">Airport</label>
              <input
                type="search"
                className="bf-input"
                placeholder="Dubai, United Arab..."
              />
            </div>
          </div>

          <div className="bf-field">
            <div className="bf-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="32"
                viewBox="0 0 26 32"
                fill="none"
              >
                <path
                  d="M12.8 16C11.04 16 9.6 14.56 9.6 12.8C9.6 11.04 11.04 9.6 12.8 9.6C14.56 9.6 16 11.04 16 12.8C16 14.56 14.56 16 12.8 16ZM22.4 13.12C22.4 7.312 18.16 3.2 12.8 3.2C7.44 3.2 3.2 7.312 3.2 13.12C3.2 16.864 6.32 21.824 12.8 27.744C19.28 21.824 22.4 16.864 22.4 13.12ZM12.8 0C19.52 0 25.6 5.152 25.6 13.12C25.6 18.432 21.328 24.72 12.8 32C4.272 24.72 0 18.432 0 13.12C0 5.152 6.08 0 12.8 0Z"
                  fill="currentColor"
                ></path>
              </svg>
            </div>
            <div className="bf-control">
              <label className="bf-label" htmlFor="">Date</label>
              <input type="date" className="bf-input" placeholder="01/07/2022" />
            </div>
          </div>

          <div className="bf-submit">
            <a href="sightseeing-lists.php" className="bf-btn-apply">
              Search
            </a>
          </div>
        </form>
      </div>
    </>
  );
};

export default SightForm;